export default __webpack_public_path__ + "static/media/themebel_main.8f600186.svg";